(function () {
  var jsonEl = document.querySelector("[data-venture-product-json]");
  if (!jsonEl) return;
  var product = JSON.parse(jsonEl.textContent);
  var wholesalePercent = parseFloat(jsonEl.getAttribute("data-wholesale-percent")) || 0;
  var form = document.querySelector("[data-venture-product-form]");
  if (!form) return;

  function displayPrice(cents) {
    if (wholesalePercent <= 0) return cents;
    return Math.round((cents * (100 - wholesalePercent)) / 100);
  }

  var idInput = form.querySelector("[data-venture-variant-id]");
  var qtyInput = form.querySelector("[data-venture-qty-input]");
  var qtyVal = form.querySelector("[data-venture-qty-val]");
  var priceEl = form.querySelector("[data-venture-price]");
  var comparePriceEl = form.querySelector("[data-venture-compare-price]");
  var klarnaEl = form.querySelector("[data-venture-klarna-amount]");
  var atcBtn = form.querySelector("[data-venture-atc-btn]");
  var atcLabel = form.querySelector("[data-venture-atc-label]");
  var stockLine = form.querySelector("[data-venture-stock-line]");
  var stockCount = form.querySelector("[data-venture-stock-count]");
  var galleryImg = document.querySelector("[data-venture-gallery-img]");
  var stickyAtc = document.querySelector("[data-venture-sticky-atc]");
  var stickyPrice = stickyAtc && stickyAtc.querySelector("[data-venture-sticky-price]");
  var stickyBtn = stickyAtc && stickyAtc.querySelector("[data-venture-sticky-btn]");

  function findVariant(selected) {
    return product.variants.filter(function (v) {
      var opts = [v.option1, v.option2, v.option3];
      return selected.every(function (val, i) { return val == null || opts[i] === val; });
    })[0];
  }

  function currentSelection() {
    var rows = form.querySelectorAll("[data-venture-option-row]");
    var selected = [];
    rows.forEach(function (row) {
      var active = row.querySelector(".is-selected");
      var idx = parseInt(row.getAttribute("data-option-index"), 10);
      selected[idx] = active ? active.getAttribute("data-value") : null;
    });
    return selected;
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString(undefined, {
      style: "currency",
      currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : "GBP",
    });
  }

  function updateAvailability(selected) {
    var rows = form.querySelectorAll("[data-venture-option-row]");
    rows.forEach(function (row) {
      var idx = parseInt(row.getAttribute("data-option-index"), 10);
      row.querySelectorAll("[data-venture-pill]").forEach(function (pill) {
        var trial = selected.slice();
        trial[idx] = pill.getAttribute("data-value");
        var match = findVariant(trial);
        pill.disabled = !match;
      });
    });
  }

  function applyVariant(variant) {
    if (!variant) {
      atcBtn.disabled = true;
      if (atcLabel) atcLabel.textContent = "Unavailable";
      return;
    }
    idInput.value = variant.id;
    var shownPrice = displayPrice(variant.price);
    if (priceEl) priceEl.textContent = formatMoney(shownPrice);
    if (stickyPrice) stickyPrice.textContent = formatMoney(shownPrice);
    if (comparePriceEl) {
      var wasPrice = Math.max(variant.compare_at_price || 0, variant.price);
      if (wasPrice > shownPrice) {
        comparePriceEl.textContent = formatMoney(wasPrice);
        comparePriceEl.style.display = "";
      } else {
        comparePriceEl.style.display = "none";
      }
    }
    if (klarnaEl) klarnaEl.textContent = formatMoney(Math.round(shownPrice / 4));

    var available = variant.available;
    atcBtn.disabled = !available;
    if (stickyBtn) stickyBtn.disabled = !available;
    if (atcLabel) {
      atcLabel.textContent = available ? "Add to Cart — " + formatMoney(shownPrice) : "Sold Out";
    }

    if (stockLine) {
      var qty = parseInt(qtyVal.textContent, 10) || 1;
      var showStock = variant.inventory_management === "shopify" && variant.inventory_quantity > 0 && variant.inventory_quantity <= 10;
      stockLine.hidden = !showStock;
      if (showStock && stockCount) stockCount.textContent = variant.inventory_quantity;
    }

    if (galleryImg && variant.featured_image) {
      var sep = variant.featured_image.src.indexOf("?") > -1 ? "&" : "?";
      galleryImg.src = variant.featured_image.src + sep + "width=900";
    }
  }

  form.querySelectorAll("[data-venture-pill]").forEach(function (pill) {
    pill.addEventListener("click", function () {
      var row = pill.closest("[data-venture-option-row]");
      row.querySelectorAll("[data-venture-pill]").forEach(function (p) { p.classList.remove("is-selected"); });
      pill.classList.add("is-selected");
      var selected = currentSelection();
      updateAvailability(selected);
      applyVariant(findVariant(selected));
    });
  });

  var minusBtn = form.querySelector("[data-venture-qty-minus]");
  var plusBtn = form.querySelector("[data-venture-qty-plus]");
  if (minusBtn && plusBtn && qtyVal && qtyInput) {
    minusBtn.addEventListener("click", function () {
      var v = Math.max(1, (parseInt(qtyVal.textContent, 10) || 1) - 1);
      qtyVal.textContent = v;
      qtyInput.value = v;
    });
    plusBtn.addEventListener("click", function () {
      var v = (parseInt(qtyVal.textContent, 10) || 1) + 1;
      qtyVal.textContent = v;
      qtyInput.value = v;
    });
  }

  document.querySelectorAll("[data-venture-thumb]").forEach(function (thumb) {
    thumb.addEventListener("click", function () {
      document.querySelectorAll("[data-venture-thumb]").forEach(function (t) { t.classList.remove("is-active"); });
      thumb.classList.add("is-active");
      if (galleryImg) galleryImg.src = thumb.getAttribute("data-full");
    });
  });

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    if (atcBtn.disabled) return;
    atcBtn.disabled = true;
    if (atcLabel) { var prevLabel = atcLabel.textContent; atcLabel.textContent = "Adding…"; }

    fetch(window.routes ? window.routes.cart_add_url : "/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: idInput.value, quantity: parseInt(qtyInput.value, 10) || 1 }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        atcBtn.disabled = false;
        if (atcLabel) atcLabel.textContent = prevLabel;
        if (data.status) {
          alert(data.description || "This item couldn't be added to your cart.");
        }
      })
      .catch(function () {
        atcBtn.disabled = false;
        if (atcLabel) atcLabel.textContent = prevLabel;
      });
  });

  // Initial availability pass (options already reflect the server-selected variant)
  updateAvailability(currentSelection());
})();